import React from 'react';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballRTI = () => {
  const { tenant, siteSettings } = useTenant();

  const rtiInfo = siteSettings?.rti || {
    name: tenant?.name || 'Throwball Federation of India',
    address: 'House No. 336, Village Khera Khurd, Delhi - 110082, India',
    phone: '+91 99999 69966',
    email: 'nareshmannthrowballindia@gmail.com',
    social: {
      facebook: 'https://www.facebook.com/throwballIndia',
      instagram: '#'
    }
  };

  return (
    <section className="tb-page-section tb-rti-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.rti || '/theme/assets/images/banner-3.jpg'} alt="RTI Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">RTI</h1>
            <span className="tb-mini-line"></span>
          </div>

          <div className="tb-rti-container">
            <div className="tb-contact-card">
              <h3 className="tb-contact-title">{rtiInfo.name}</h3>

              <div className="tb-contact-item">
                <i className="ri-map-pin-line"></i>
                <div dangerouslySetInnerHTML={{ __html: rtiInfo.address.replace(/,/g, '<br />') }} />
              </div>

              <div className="tb-contact-item">
                <i className="ri-phone-line"></i>
                <a href={`tel:${rtiInfo.phone.replace(/\s/g, '')}`} className="tb-contact-link">
                  {rtiInfo.phone}
                </a>
              </div>

              <div className="tb-contact-item">
                <i className="ri-mail-line"></i>
                <a href={`mailto:${rtiInfo.email}`} className="tb-contact-link">
                  {rtiInfo.email}
                </a>
              </div>

              <div className="tb-follow-box">
                <h4 className="tb-follow-txt">Follow us on:</h4>
                <ul className="tb-social-links">
                  <li>
                    <a href={rtiInfo.social?.facebook || 'https://www.facebook.com/throwballIndia'} target="_blank" rel="noopener noreferrer" className="tb-social-link">
                      <i className="ri-facebook-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a href={rtiInfo.social?.instagram || '#'} className="tb-social-link">
                      <i className="ri-instagram-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThrowballRTI;
